import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import { Localized } from '../../localization/react'

export function VerificationTransactionFeeDisclaimer() {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        background: '#F2E7FE',
        borderRadius: 1,
        padding: 2,
        fontSize: '14px',
      }}
    >
      <Icon icon={Icons.INFO} color="secondary.main" size="large" />
      <Text sx={{ color: 'midnight' }}>
        <Localized id="payment-info-banner-ideal" />
      </Text>
    </Stack>
  )
}
